// Loads Pylon's chat widget. This used to be an inline snippet in index.html; it lives here so the page needs
// no inline scripts (CSP script-src without 'unsafe-inline'). The stub queues calls made via window.Pylon
// (see usePylon.js) until the widget script has loaded and drains the queue.
export function loadPylon(appId = import.meta.env.VITE_PYLON_APP_ID) {
    if (!appId || window.Pylon) return

    const stub = function () {
        stub.e(arguments)
    }
    stub.q = []
    stub.e = function (args) {
        stub.q.push(args)
    }
    window.Pylon = stub

    const injectWidgetScript = () => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = `https://widget.usepylon.com/widget/${appId}`
        document.head.appendChild(script)
    }

    if (document.readyState === 'complete') {
        injectWidgetScript()
    } else {
        window.addEventListener('load', injectWidgetScript, false)
    }
}
